/**
 * @hidden
 */
export var getActiveElement = function (document) {
    if (!document) {
        return undefined;
    }
    var activeElement = document.activeElement;
    var shadowRoot = activeElement === null || activeElement === void 0 ? void 0 : activeElement.shadowRoot;
    return shadowRoot ? shadowRoot.activeElement : activeElement;
};
